import React, { useEffect } from 'react'
import './EngineeringServices.css'
const EngineeringServices = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top of the page
    }, []);


    return (

        <>

            <div className="floating-icons">
                <a className="icon">
                    <button

                        className="sm_icon"
                    >
                        <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
                    </button>
                </a>
                <a className="icon">
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
                    </button>
                </a>
                <a className="icon">
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
                    </button>
                </a>
                <a className="icon">
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
                    </button>
                </a>
            </div>



            <div className='EngineeringServices_banner'>
                <h3>Engineering & Services</h3>
            </div>

            <div className='EngineeringServices_component'>

                <div className='container-fluid'>
                    <div className='engineering_services_content'>
                        <p>At HAMO Tech, our Engineering & Services solutions are designed to help businesses unlock their full potential through advanced technology and expert execution. From ideation to implementation, we deliver innovative, scalable, and efficient services tailored to your unique needs.</p>


                        <p>At HAMO Tech, we specialize in delivering cutting-edge engineering solutions and comprehensive IT services tailored to meet the evolving needs of our clients. Our engineering team is adept at designing, implementing, and maintaining robust systems that drive operational efficiency and innovation. From conceptualizing complex technical solutions to deploying them seamlessly, we ensure that every project is executed with precision and a commitment to excellence.</p>

                        <p>Our services are built on a foundation of industry best practices, utilizing state-of-the-art tools and technologies. Whether it's software development, infrastructure management, or systems engineering, we emphasize scalability, security, and performance in every solution we deliver. We partner with clients across industries, empowering them to overcome technical challenges, streamline operations, and achieve long-term success.</p>

                        <p>With a strong focus on collaboration and client satisfaction, our team provides end-to-end support at every stage of the project lifecycle. From initial consultation to post-deployment maintenance, we work closely with you to understand your goals and deliver results that exceed expectations. By combining technical expertise with a deep understanding of industry trends, HAMO Tech helps businesses stay competitive in an ever-changing digital landscape.</p>

                        <p>At the heart of our approach lies a commitment to innovation and quality. Whether you're looking to modernize your existing systems, integrate cutting-edge technologies, or build entirely new solutions, HAMO Tech is your trusted partner for engineering excellence and IT services that truly make a difference.</p>


                        <h4> Our Services at a Glance</h4>
                        <h6>1. Custom Solutions Development</h6>
                        <p>Build smarter, faster, and reliable systems that align with your business goals.</p>


                        <h6>2. End-to-End IT Services</h6>
                        <p>Manage and optimize your IT infrastructure to achieve seamless operations with minimal downtime.</p>

                        <h6>3. Automation & Optimization</h6>
                        <p>Integrate advanced automation tools to boost productivity and reduce operational costs.</p>

                        <h6>4. Cloud Engineering & Migration</h6>
                        <p>Transform your operations with cloud-based solutions, ensuring flexibility and scalability.</p>

                        <h6>5. Engineering Support</h6>
                        <p>Reliable engineering solutions to tackle everyday challenges in diverse industries, from manufacturing to tech.</p>

                        <h6>6. Technical Consulting</h6>
                        <p>Get expert advice to design strategies and implement projects with confidence and precision.</p>

                        <h6>Our Approach</h6>
                        <p> At HAMO Tech, we believe in delivering value-driven solutions that empower businesses to thrive in a competitive market. We focus on :</p>




                        <ul>
                            <li>Tailored Strategies: Every project is designed to meet your specific business objectives.</li>
                            <li>Future-Ready Solutions: Leveraging cutting-edge technologies to future-proof your operations.</li>
                            <li>Collaboration-Driven Outcomes: Our team works closely with you to ensure your vision comes to life.</li>
                        </ul>
                        {/*
                    <h4>Why Choose HAMO Tech?</h4>
                    <ul>
                        <li>  A team of certified experts with industry-leading experience.</li>
                        <li>Proven track record of delivering high-quality engineering solutions.</li>
                        <li>Commitment to innovation, efficiency, and sustainability.</li>
                        <li>Timely delivery with a customer-first approach.</li>
                    </ul>
                    <h4>Ready to Take the Next Step?</h4>
                    <p> Empower your business with innovative engineering and IT solutions. Whether you’re launching a new project or improving existing systems, we’re here to help you succeed.</p>
 */}
                        <h4>For More Details, Contact Us Today
                        </h4>
                        <p>Let’s discuss how we can turn your challenges into opportunities.</p>

                        <div className='text-center'>
                            <button type="button" className='btn btn-danger' data-toggle="modal" data-target="#myModal">Contact Us</button>


                            <div id="myModal" class="modal fade" role="dialog">
                                <div class="modal-dialog modal-lg">


                                    <div class="modal-content" style={{ position: 'relative' }}>
                                        <button
                                            type="button" class="close" data-dismiss="modal"

                                            style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-5px',
                                                cursor: 'pointer',
                                                backgroundColor: '#ffffff',
                                                border: 'none',
                                                fontSize: '14px',
                                                color: 'gray',
                                                opacity: 1,
                                                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                                                padding: '7px',
                                                borderRadius: '50%',
                                            }}
                                        >
                                            <i class="ri-close-fill"></i>
                                        </button>


                                        <form className='|'>

                                            <div className='text-left'>
                                                <h5 style={{ color: "#e65753" }}>Get in Touch with HAMO Tech for Engineering Solutions</h5>
                                                <p>Whether you're looking for innovative product designs, customized engineering solutions, or reliable testing and quality assurance services, HAMO Tech is here to help. Fill out the form below to let us know your requirements, and our team will get back to you promptly with tailored solutions.</p>
                                            </div>
                                            <input type="text" placeholder='Enter Name' className='form-control' />

                                            <input type="email" placeholder='Enter Email' className='form-control' />

                                            <input type="number" placeholder='Enter Number' className='form-control' />

                                            <select className='form-control'>
                                                <option hidden>Select Services</option>
                                                <option>Engineering Services</option>
                                                <option>Training</option>
                                                <option>Consulting</option>
                                                <option>Others</option>
                                            </select>

                                            <textarea placeholder='Enter Description' className='form-control' rows='7' />

                                            <button className='btn btn-danger es_form_sub_btn'>Submit</button>
                                        </form>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EngineeringServices
